import React from 'react';
import FSBOPropertySearch from './FSBOPropertySearch.js';

var FSBOPropertySearchBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var id = attrs.id;
    return /*#__PURE__*/React.createElement(FSBOPropertySearch, {
      id: id
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/fsbo-search',
    title: 'FSBO Search Component',
    description: 'FSBO Search Component',
    icon: 'search',
    keywords: ['fsbo', 'search'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Search',
    attributes: {
      id: {
        type: 'string'
      }
    }
  }
};
var FSBOPropertySearchBlock$1 = FSBOPropertySearchBlock;

export { FSBOPropertySearchBlock$1 as default };
